import { RootState } from '../root-store';
import { createSelector } from 'reselect';

export const durinalBalanceState = (state: RootState) => state.durinalBalance;
export const getDayBallance = createSelector(
	durinalBalanceState,
	(state) => state.dietBallanceItems
);
